/**
 * @generated SignedSource<<70b32d41620071822bb3f7509e9b27a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type EventVisibility = "cohort" | "member_group" | "public" | "%future added value";
export type OccurrenceStatus = "draft" | "published" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentUsageFormEventsField_OccurrenceFragment$data = {
  readonly content: {
    readonly name: string | null;
  };
  readonly datetimeRange: ReadonlyArray<string>;
  readonly id: string;
  readonly status: OccurrenceStatus;
  readonly visibility: EventVisibility;
  readonly " $fragmentSpreads": FragmentRefs<"OccurrenceNameAndTimeFragment">;
  readonly " $fragmentType": "ContentUsageFormEventsField_OccurrenceFragment";
};
export type ContentUsageFormEventsField_OccurrenceFragment$key = {
  readonly " $data"?: ContentUsageFormEventsField_OccurrenceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentUsageFormEventsField_OccurrenceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentUsageFormEventsField_OccurrenceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "datetimeRange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OccurrenceNameAndTimeFragment"
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "7b1f50ded68304363781ae08a9691657";

export default node;
